export const formatDate = (date: string): string => {
  return new Date(date).toLocaleDateString("en-GB", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

export const formatBoolean = (value: boolean): string => {
  if (value === null || value === undefined) return "N/A";
  return value ? "Yes" : "No";
};